const isAbsoluteHttp = (value: string) => /^https?:\/\//i.test(value);
const isProtocolRelative = (value: string) => value.startsWith("//");
const isDataUrl = (value: string) => value.startsWith("data:");
const isBlobUrl = (value: string) => value.startsWith("blob:");

export const normalizeMediaUrl = (value: unknown): string => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (isAbsoluteHttp(trimmed) || isDataUrl(trimmed) || isBlobUrl(trimmed)) return trimmed;
  if (isProtocolRelative(trimmed)) return `https:${trimmed}`;

  const withoutLeading = trimmed.replace(/^\/+/, "");
  const firstSegment = withoutLeading.split("/")[0] || "";
  const hasHost = firstSegment.includes(".");
  const hasPath = withoutLeading.includes("/");

  if (hasHost && hasPath) {
    return `https://${withoutLeading}`;
  }

  return `/${withoutLeading}`;
};
